// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"b2bdfa4d","235":"0203a916","253":"200ed7f1","257":"6c743366","323":"6df43fc8","480":"97a231f5","599":"34c3d9c3","723":"3981e21d","796":"8eae393a","966":"699117c6"}[chunkId] + ".chunk.js";
};